import { useSEO } from '../../utils/seo';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ProductsSection from './components/ProductsSection';
import GallerySection from './components/GallerySection';
import ReviewsSection from './components/ReviewsSection';
import ServiceAreasSection from './components/ServiceAreasSection';
import CTASection from './components/CTASection';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://funtimephotobooths.com';

  useSEO({
    title: 'San Diego Photo Booth & Overhead 360 Video Booth | Fun Time Photobooths',
    description: 'Premium photo booth & overhead 360 video booth rentals in San Diego for weddings, corporate events & celebrations. Professional equipment, instant sharing, and unforgettable experiences.',
    keywords: 'photo booth San Diego, 360 video booth, overhead 360 booth, wedding photo booth, corporate event photo booth, San Diego photobooth rental',
    canonical: `${siteUrl}/`,
    ogTitle: 'San Diego Photo Booth & Overhead 360 Video Booth | Fun Time Photobooths',
    ogDescription: 'Show-stopping photo & video booths for weddings, corporate events, and celebrations that deserve more than ordinary.',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'Fun Time Photobooths',
      description: 'Premium photo booth and overhead 360 video booth rentals in San Diego for weddings, corporate events, and celebrations.',
      url: siteUrl,
      telephone: '+14424160576',
      email: 'luis@funtimephotobooths.com',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'San Diego',
        addressRegion: 'CA',
        addressCountry: 'US',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '32.7157',
        longitude: '-117.1611',
      },
      areaServed: {
        '@type': 'City',
        name: 'San Diego',
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
          opens: '09:00',
          closes: '21:00',
        },
      ],
      priceRange: '$$',
      image: 'https://static.readdy.ai/image/4e6cb48aacd8b48acab6684eff653bcc/4232dc6dcf725cfb6d83db801a927370.jpeg',
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '127',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Photo Booth Services',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Overhead 360 Video Booth',
              description: 'State-of-the-art overhead 360 video booth with slow-motion effects and instant sharing.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Signature Photo Booth',
              description: 'Premium photo booth with unlimited prints, custom templates, and professional attendants.',
            },
          },
        ],
      },
    },
  });

  return (
    <div className="min-h-screen">
      <Navigation />
      <HeroSection />
      <FeaturesSection />
      <ProductsSection />
      <GallerySection />
      <ReviewsSection />
      <ServiceAreasSection />
      <CTASection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
